import React from 'react';
import { compose } from 'ramda';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import Router from 'components/Router/Router';
import { makeStyles } from '@material-ui/styles';
import { Notify } from 'utils';
import withCaseInfo from 'hoc/withCaseInfo';
import ExperienceQuestionnaire from 'components/ExperienceQuestionnaire/ExperienceQuestionnaire';

const useStyles = makeStyles({
  content: {
    flexGrow: 1,
    padding: '2rem',
    position: 'relative',
    width: 'calc(100% - 68px)',
    overflow: 'hidden',
    '@media (min-width: 1280px)': {
      paddingLeft: '3%',
      paddingRight: '3%'
    },
    '@media (min-width: 1720px)': {
      paddingLeft: '8%',
      paddingRight: '8%'
    },
    '@media (min-width: 1920px)': {
      paddingLeft: '12%',
      paddingRight: '12%'
    }
  }
});

const { useParams, useHistory } = Router;

const ExperienceQuestionnairePage = () => {
  const { portfolio, customer } = useParams() as any;
  const history = useHistory();
  const classes = useStyles();

  return (
    <Dashboard>
      <div className={classes.content}>
        <ExperienceQuestionnaire
          customer={customer}
          portfolio={portfolio}
          onSuccess={() => {
            Notify.success('Questionnare', 'Questionnaire was saved');
            history.push(`/${portfolio}/risk-summary`);
          }}
        />
      </div>
    </Dashboard>
  );
};

export default compose(withCaseInfo)(ExperienceQuestionnairePage);
